import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import {Box,Typography,Menu, MenuItem,Button} from '@mui/material';
import Divider from '@mui/material/Divider';
import {livedata} from '../../../../Restclient/datacollection'



export default function WaterMultiValueCard(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    // const [tags,setTags]=
    const Tags=props.widgetprop.props.extended.tagprops

    useEffect(() => {
        const tagProperties = props.widgetprop.props.extended.tagprops;
        
        // tagProperties.forEach(chartType => {
            
        //     if (tagcollectionvalue.hasOwnProperty(chartType.tagname)) {
        //         var nestedvalue = tagcollectionvalue[chartType.tagname]
        //         let sum = 0.0;
        //         let min = 0.0;
        //         let max = 1000000000000;
        //             for(let i=0;i<nestedvalue.length;i++){
        //                 if(nestedvalue[i].y > min){
        //                     max = nestedvalue[i].y;
        //                 }else if(nestedvalue[i].y < max){
        //                     min = nestedvalue[i].y;
        //                 }
        //             }
        //         setOptionsMin(min);
        //         setOptionsMax(max);

                
        //     }
        // })
       
        
      },[props.widgetprop, tagcollectionvalue])

      useEffect(()=>{
        livedata(callback);
      },[props])

      const [data,setData]=useState([]);

      function useApiPolling(apiFunction, delay) {
        const [data, setData] = useState(null);
        console.log("in api")
        useEffect(() => {
          const fetchData = async () => {
            try {
              const response = await apiFunction((callback));
              setData(response);
              console.log("in try",response)
            } catch (error) {
              console.log("in catch")
              console.error(error);
            }
          };
      
          const intervalId = setInterval(fetchData, delay);
      
          // Clear the interval on unmount
          return () => clearInterval(intervalId);
        }, [apiFunction, delay]);
      
        return data;
      }

      function Live(){
        console.log("in live");
        useApiPolling(livedata,15000);
        return(
          <></>
        )
      }


      function callback(res){
        console.log("in table in live data",res.data);
        // uid="WL4410";
        let parainfo={} ,temp=[];
        //const newds = [...dataSource]/;/lllll
        res.data.map((dataarr)=>{
        //   dataarr.map((val,index)=>{
        //     // if(val.Device==uid){
        //     //   if(val.Status==1){
        //     //     connstate("Connected");
        //     //     dataSource.map((dsval,dsindex)=>{
        //     //       console.log("dsval",dsval,dataarr,val)
        //     //       var keyvalue = "no value";
        //     //      // keyvalue.then
        //     //       //var keyvalue;
        //     //       //console.log
        //     //       //Object.keys((val.data))
        //     //       //.forEach(key => {
        //     //        // if (key ===  dsval.parameter){ }
        //     //       //})
        //     //       if(dsval.active==='true'){
        //     //          console.log("in true");
        //     //          Object.entries(val.Data).forEach((key)=>{
        //     //            console.log("hi in if",key,"-----",dsval.parameter)
        //     //            if (key[0] ===  dsval.parameter){
        //     //                console.log("hi in ifpppppppppppp",key)
        //     //                keyvalue=key[1];
        //     //            }
        //     //          })
        //     //       }
                   
        //     //      //console.log("keyvalue",keyvalue,val.timestamp)
        //     //      //dataSource[dsindex].value = value[1]////
        //     //      parainfo={key: dataSource[dsindex].key,
        //     //        parameter: dataSource[dsindex].parameter,
        //     //        datatype: dataSource[dsindex].datatype,
        //     //        alias: dataSource[dsindex].alias,
        //     //        value:keyvalue,
        //     //        timestamp: val.timestamp,
        //     //        unit: dataSource[dsindex].unit,
        //     //        active: dataSource[dsindex].active,
        //     //        storage: dataSource[dsindex].storage,}
        //     //      //newds[dsindex].value=keyvalue[1]
        //     //      temp=[...temp,parainfo];
        //     //     })
        //     //     //console.log("val.Status==1 if",val.Status)
        //     //   }else{
        //     //     //console.log("val.Status==1 else",val.Status)
        //     //     connstate("Disconnected");
        //     //   }
        //     // }
            
        //     //setdata([dataarr[1].Data.MMXU.MX.PhV.phsB.f])
        //     console.log("in water",val.Data,dataarr,/*dataarr[1].Data.MMXU.MX.PhV.phsB.f*/)
        //   })
        //console.log("in water",dataarr,dataarr[1].Data.MMXU.MX.PhV.phsB.f)
        Object.entries(dataarr).forEach((key)=>{
            console.log("hi in if",key)
            if (key[0] === "VFDS"   ){
                console.log("hi in ifpppppppppppp",key)
                // keyvalue=key[1];
                // console.log("hi in if",key,"-----",)
                temp=[...temp,key]
            }
          })


        })
        // setDataSource(temp);
        console.log(temp,"for temp0000=")
        if(props.widgetprop.widgetname=='VFD Status'){
        setData(temp[0][1]==0?'OFF':'ON');
        }
        // else if(props.widgetprop.widgetname=='DC Voltage (V)'){
        // setData(temp[1][1]);
        // }
        // else if(props.widgetprop.widgetname=='Water Analysis Data'){
        // setData([temp[3][1],temp[7][1],temp[8][1]]);
        // }

      }

      console.log("waterbbbb",props)
    return(
        <Box sx={{height:"100%",border:"0px solid var(--LK_BrandBlue)",boxSizing:'border-box'}}>
            <Live/>
            <Box sx={{height:"15%", width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                <Typography sx={{marginLeft: '15px',marginTop:"8px", color: 'var(--LK_BrandBlue_1)', fontSize: '16px', fontWeight: 700,fontFamily:"Roboto"}}> {props.widgetprop.widgetname} </Typography>
            </Box>
            {console.log(Tags,"Tagd")}
            <Box sx={{height:"85%", width: '100%', display: 'flex',flexDirection:'row', alignItems: 'center',boxSizing:'border-box', justifyContent: 'start',padding:'0px 0px 16px 0px'}}>
                <Box sx={{height:"100%", width: '100%', display: 'flex',flexDirection:'column', alignItems: 'center', justifyContent:'start',padding:'8px',boxSizing:'border-box',gap:'8px'}} >
                    <Box sx={{height:"50%",width:"100%", display: 'flex',flexDirection:'row', alignItems: 'end', justifyContent: 'flex-start',justifyItems:"left",justifySelf:'left'}}>
                        <Typography sx={{marginLeft: '15px',marginTop:"8px",width:'65%', color: theme=='dark'?'#EFEFEF':'#000000', fontSize: '16px', fontWeight: 400,fontFamily:"Roboto",textAlign:"left",boxSizing:'border-box',}}>{Tags[0].tagname}  </Typography>
                        <Typography sx={{marginLeft: '15px',marginTop:"8px",width:'35%', color: theme=='dark'?'#EFEFEF':'#000000', fontSize: '20px', fontWeight: 400,fontFamily:"Roboto",textAlign:"left",boxSizing:'border-box',}}>{data}  </Typography>
                    </Box>
                    <Box sx={{height:"50%", width:"100%",display: 'flex',flexDirection:'row', alignItems: 'start', justifyContent: 'left',justifyItems:'left'}}>
                        <Typography sx={{marginLeft: '15px',marginTop:"8px",width:'65%', color: theme=='dark'?'#EFEFEF':'#000000', fontSize: '16px', fontWeight: 400,fontFamily:"Roboto",textAlign:"left",boxSizing:'border-box',}}>{Tags[1].tagname}  </Typography>
                        <Typography sx={{marginLeft: '15px',marginTop:"8px",width:'35%', color: theme=='dark'?'#EFEFEF':'#000000', fontSize: '20px', fontWeight: 400,fontFamily:"Roboto",textAlign:"left",boxSizing:'border-box',}}>OFF  </Typography>
                    </Box>
                    {/* {Tags.length>0?
                     <>
                        {Tags.map(()=>{
                                <Typography sx={{marginTop:"8px", color: theme=='dark'?'#EFEFEF':'#000000', fontSize: '20px', fontWeight: 400,fontFamily:"Roboto"}}>{Tags[0].tagname}  </Typography>
                        })}
                     </>
                     :
                     <>
                     </>
                    } */}
                </Box>
            </Box>
        </Box>
    )
}